import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setLoader } from '../../../../../../redux/app/app.actions';

const LoadingFlow = ({ message = "We're almost there..." }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLoader(true, message));
  }, [dispatch, message]);

  return (
    <div className="auth-loading-flow">
      <div className="auth-card-header">
        <h2 className="auth-card-title">Loading</h2>
      </div>
      <div className="auth-loading-message">
        {message}
      </div>
    </div>
  );
};

export default LoadingFlow;
